/**
 * Time Piece Coffee LP
 * - スクロールで現れる動き（文字・写真・数値・工程・味わい）
 * - 写真の視差、読んでいる行の強調（案D）
 * - ファーストビュー動画の音声ボタン
 * - カップの色の切り替え（案C-1）と、3Dカップの読み込み
 * - スマホの追従ボタン（ほかの登録ボタンが見えている間は隠す）
 * - テーマエディタでの再読み込み対応
 */
(function () {
  'use strict';

  window.TPC_READY = true;

  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var hasIO = 'IntersectionObserver' in window;

  function each(list, fn) {
    Array.prototype.forEach.call(list, fn);
  }

  function isVisible(el) {
    return !!(el && el.getClientRects().length);
  }

  /* ================================================================
     スクロールで現れる動き
     ================================================================ */
  var REVEAL = [
    '[class*="__head"] > *',
    '.tpc-spec__row',
    '.tpc-fold',
    '.tpc-pillar__media',
    '.tpc-pillar__note',
    '.tpc-a-box__visual',
    '.tpc-a-box__row',
    '.tpc-a-series__item',
    '.tpc-a-series__note',
    '.tpc-a-series__sub > *',
    '.tpc-a-series__story-body > *',
    '.tpc-a-essay__lead',
    '.tpc-a-essay__text',
    '.tpc-a-essay__note',
    '.tpc-b-series__item',
    '.tpc-feature__media',
    '.tpc-feature__body > *',
    '.tpc-cards__item',
    '.tpc-cards__after',
    '.tpc-cards__note',
    '.tpc-statement__text',
    '.tpc-c1-view__picker',
    '.tpc-c1-play__figure',
    '.tpc-c1-play__qr',
    '.tpc-c1-play__card',
    '.tpc-c1-play__note',
    '.tpc-c1-parts__photo',
    '.tpc-c1-colors__series',
    '.tpc-c2-process__figure',
    '.tpc-num',
    '.tpc-step',
    '.tpc-c2-process__note',
    '.tpc-c2-point',
    '.tpc-c2-gc',
    '.tpc-c2-tag',
    '.tpc-c2-chapter__closing',
    '.tpc-c2-scene__body > *',
    '.tpc-c2-points__item',
    '.tpc-c2-trio__item',
    '.tpc-c2-chapter__cta > *',
    '.tpc-c2-blends__item',
    '.tpc-c2-blends__note',
    '.tpc-d-series__item',
    '.tpc-tier',
    '.tpc-returns__note',
    '.tpc-returns__row',
    '.tpc-returns__sets',
    '.tpc-returns__cta',
    '.tpc-returns__sub',
    '.tpc-returns__after',
    '.tpc-chap--overlay .tpc-chap__para',
    '.tpc-chap__body > *',
    '.tpc-chap__closing',
    '.tpc-register__body > *',
    '.tpc-faq__item',
    '.tpc-story__p',
    '.tpc-story__closing',
    '.tpc-footer__inner > *'
  ].join(',');

  // 写真は、ピントが合うように現れる
  var REVEAL_IMG = [
    '.tpc-pillar__img',
    '.tpc-feature__img',
    '.tpc-cards__img',
    '.tpc-c2-process__img',
    '.tpc-c2-chapter__img',
    '.tpc-c2-point__img',
    '.tpc-c2-scene__img',
    '.tpc-story__img',
    '.tpc-chap__img',
    '.tpc-d-series__img',
    '.tpc-b-series__img',
    '.tpc-c1-play__figure-img',
    '.tpc-c1-play__card-img',
    '.tpc-c1-parts__photo-img',
    '.tpc-returns__img',
    '.tpc-a-series__media',
    '.tpc-statement__media'
  ].join(',');

  // 画面に入ったときに .is-in を付けて再生するもの
  var TRIGGERS = [
    '.tpc-chars--scroll',
    '.tpc-lines--scroll',
    '.tpc-ripple--scroll',
    '.tpc-rating',
    '.tpc-c2-process__steps',
    '.tpc-c2-trio__venn'
  ].join(',');

  // ファーストビュー・ヘッダーは、CSSの演出にまかせる
  var EXCLUDE = '.tpc-a-hero, .tpc-b-hero, .tpc-c1-hero, .tpc-c2-hero, .tpc-d-hero, .tpc-header';

  var io = hasIO
    ? new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            e.target.classList.add('is-in');
            io.unobserve(e.target);
            if (typeof e.target.__tpcOnIn === 'function') e.target.__tpcOnIn();
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
      )
    : null;

  function isBelowFold(el) {
    var r = el.getBoundingClientRect();
    return r.top > (window.innerHeight || document.documentElement.clientHeight) * 0.92;
  }

  /* 案A：写真に文章を重ねる章（概要）より下は、1行・1枚ずつではなく、セクションの上端が画面に入ったときに、中身をまとめて表示する（2026-10-20） */
  var secIO = hasIO
    ? new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            // セクションの上端が画面に入ったら、その中の文章・写真をまとめて最後まで表示する（背景は最初から表示したまま）
            each(e.target.querySelectorAll('.tpc-rv:not(.is-in), .tpc-rv-img:not(.is-in)'), function (el) {
              el.classList.add('is-in');
            });
            secIO.unobserve(e.target);
          });
        },
        { rootMargin: '0px 0px -10% 0px', threshold: 0 }
      )
    : null;

  function sectionModeWrappers() {
    var list = [];
    // 案A：写真に文章を重ねる章（概要）より下／案C-1：ファーストビューより下（2026-10-25）
    var ov = document.querySelector('.tpc--a .tpc-chap--overlay') || document.querySelector('.tpc--c1 .tpc-c1-hero');
    var wrap = ov && ov.closest('.shopify-section');
    for (var n = wrap && wrap.nextElementSibling; n; n = n.nextElementSibling) {
      // スクロールで1段落ずつ読ませるセクション（案C-1の3D VIEW）は、いつもの1つずつの現れ方のまま
      if (n.classList && n.classList.contains('shopify-section') && !n.querySelector('[data-tpc-view-scroll]')) list.push(n);
    }
    return list;
  }

  function inSectionMode(el, wraps) {
    for (var i = 0; i < wraps.length; i++) if (wraps[i].contains(el)) return true;
    return false;
  }

  function initReveal(scope) {
    var instant = reduceMotion || designMode || !io;
    var counts = typeof Map === 'function' ? new Map() : null;
    var secWraps = sectionModeWrappers();

    each(secWraps, function (w) {
      if (w.__tpcRs) return;
      w.__tpcRs = true;
      if (instant || !secIO || !isBelowFold(w)) return;
      // 中の文章・写真には、いつもの現れ方（.tpc-rv／.tpc-rv-img）を付けておき、セクション単位で一斉に再生する
      each(w.querySelectorAll(REVEAL_IMG), function (el) {
        if (el.__tpcRi || el.closest(EXCLUDE)) return;
        el.__tpcRi = true;
        el.classList.add('tpc-rv-img');
      });
      each(w.querySelectorAll(REVEAL), function (el) {
        if (el.__tpcRv || el.__tpcRi || el.closest(EXCLUDE)) return;
        el.__tpcRv = true;
        el.classList.add('tpc-rv');
      });
      secIO.observe(w);
    });

    each(scope.querySelectorAll(REVEAL), function (el) {
      if (el.__tpcRv || el.closest(EXCLUDE)) return;
      if (inSectionMode(el, secWraps)) return;
      el.__tpcRv = true;
      if (instant || !isBelowFold(el)) return;
      var n = 0;
      if (counts) {
        n = counts.get(el.parentElement) || 0;
        counts.set(el.parentElement, n + 1);
      }
      el.style.setProperty('--rv-d', Math.min(n * 0.09, 0.54) + 's');
      el.classList.add('tpc-rv');
      io.observe(el);
    });

    each(scope.querySelectorAll(REVEAL_IMG), function (el) {
      if (el.__tpcRi || el.closest(EXCLUDE)) return;
      if (inSectionMode(el, secWraps)) return;
      el.__tpcRi = true;
      if (instant || !isBelowFold(el)) return;
      el.classList.add('tpc-rv-img');
      io.observe(el);
    });

    each(scope.querySelectorAll(TRIGGERS), function (el) {
      if (el.__tpcTr) return;
      el.__tpcTr = true;
      // セクションごとに現れる部分では、図（3つの円など）の動きも付けず、最初から表示しておく
      if (instant || inSectionMode(el, secWraps)) {
        el.classList.add('is-in');
        return;
      }
      io.observe(el);
    });
  }

  /* ---------- 数値が数えあがる（案C-2） ---------- */
  function formatNumber(value, decimals, comma) {
    var s = value.toFixed(decimals);
    if (comma) s = s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return s;
  }

  function countUp(el) {
    var original = el.textContent;
    var parts = original.split(/(\d[\d,]*(?:\.\d+)?)/);
    var nums = [];
    for (var i = 1; i < parts.length; i += 2) {
      var raw = parts[i];
      nums.push({
        i: i,
        value: parseFloat(raw.replace(/,/g, '')),
        decimals: (raw.split('.')[1] || '').length,
        comma: raw.indexOf(',') > -1
      });
    }
    if (!nums.length) return;
    el.style.display = 'inline-block';
    el.style.minWidth = el.getBoundingClientRect().width + 'px';
    var start = null;
    var duration = 1500;
    function tick(now) {
      if (start === null) start = now;
      var t = Math.min((now - start) / duration, 1);
      var eased = 1 - Math.pow(1 - t, 3);
      var out = parts.slice();
      nums.forEach(function (n) {
        out[n.i] = formatNumber(n.value * eased, n.decimals, n.comma);
      });
      el.textContent = t < 1 ? out.join('') : original;
      if (t < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function initCounters(scope) {
    if (!document.body.classList.contains('tpc--c2')) return;
    each(scope.querySelectorAll('.tpc-num__n'), function (el) {
      if (el.__tpcCount) return;
      el.__tpcCount = true;
      if (reduceMotion || designMode || !io) return;
      el.__tpcOnIn = function () {
        countUp(el);
      };
      io.observe(el);
    });
  }

  /* ---------- 写真の視差・読んでいる行の強調 ---------- */
  var parallaxItems = [];
  var focusLines = [];

  function initParallax(scope) {
    if (reduceMotion || designMode) return;
    each(
      // 写真を少し拡大して動かすので、端まで見せたい写真（エッセイの話・案Dのコーヒーの導入）は対象から外す
      scope.querySelectorAll('.tpc-statement--ripple .tpc-statement__img, .tpc-statement--none:not(#craft) .tpc-statement__img'),
      function (img) {
        if (img.__tpcPx) return;
        img.__tpcPx = true;
        img.setAttribute('data-tpc-parallax', '');
        parallaxItems.push(img);
      }
    );
  }

  function initFocus(scope) {
    if (reduceMotion || designMode) return;
    each(scope.querySelectorAll('[data-tpc-focus] .tpc-line'), function (line) {
      if (line.__tpcFocus) return;
      line.__tpcFocus = true;
      focusLines.push(line);
    });
  }

  function updateScrollEffects() {
    var vh = window.innerHeight || document.documentElement.clientHeight;
    parallaxItems = parallaxItems.filter(function (img) {
      return document.contains(img);
    });
    parallaxItems.forEach(function (img) {
      var box = (img.parentElement || img).getBoundingClientRect();
      if (box.bottom < -200 || box.top > vh + 200) return;
      var offset = box.top + box.height / 2 - vh / 2;
      img.style.setProperty('--py', (offset * -0.07).toFixed(1) + 'px');
    });
    focusLines = focusLines.filter(function (line) {
      return document.contains(line);
    });
    focusLines.forEach(function (line) {
      var r = line.getBoundingClientRect();
      if (r.bottom < -100 || r.top > vh + 100) return;
      var distance = Math.abs(r.top + r.height / 2 - vh * 0.5) / (vh * 0.5);
      var f = Math.max(0, Math.min(1, 1 - distance * 1.2));
      line.style.setProperty('--f', f.toFixed(3));
    });
  }

  // ページの最後までスクロールしたら、まだ現れていないものをすべて表示する
  function revealRestAtBottom() {
    var doc = document.documentElement;
    var bottom = (window.scrollY || window.pageYOffset) + (window.innerHeight || doc.clientHeight);
    if (bottom < doc.scrollHeight - 4) return;
    each(document.querySelectorAll('.tpc-rv:not(.is-in), .tpc-rv-img:not(.is-in)'), function (el) {
      el.classList.add('is-in');
      if (io) io.unobserve(el);
    });
    each(document.querySelectorAll(TRIGGERS), function (el) {
      if (el.classList.contains('is-in')) return;
      el.classList.add('is-in');
      if (io) io.unobserve(el);
    });
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      updateScrollEffects();
      revealRestAtBottom();
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  /* ================================================================
     音声ボタン（ファーストビューに動画があるときだけ表示）
     ================================================================ */
  function currentVideo() {
    var videos = document.querySelectorAll('[data-tpc-video] video');
    for (var i = 0; i < videos.length; i++) {
      if (isVisible(videos[i])) return videos[i];
    }
    return null;
  }

  function syncSound(btn) {
    var video = currentVideo();
    var on = !!(video && !video.muted);
    btn.hidden = !video;
    btn.classList.toggle('is-on', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', on ? '音声をオフにする' : '音声をオンにする');
  }

  function initSound() {
    each(document.querySelectorAll('[data-tpc-sound]'), function (btn) {
      if (!btn.getAttribute('data-tpc-ready')) {
        btn.setAttribute('data-tpc-ready', '1');
        btn.addEventListener('click', function () {
          var video = currentVideo();
          if (!video) return;
          video.muted = !video.muted;
          if (!video.muted) {
            var p = video.play();
            if (p && typeof p.catch === 'function') p.catch(function () {});
          }
          syncSound(btn);
        });
      }
      syncSound(btn);
    });
  }

  /* ================================================================
     カップの色の切り替え（案C-1）
     ================================================================ */
  function initPickers() {
    each(document.querySelectorAll('[data-tpc-picker]'), function (root) {
      if (root.getAttribute('data-tpc-ready')) return;
      root.setAttribute('data-tpc-ready', '1');
      var img = root.querySelector('[data-tpc-picker-img]');
      var label = root.querySelector('[data-tpc-picker-label]');
      var chips = root.querySelectorAll('[data-src]');
      each(chips, function (chip) {
        chip.addEventListener('click', function () {
          each(chips, function (c) {
            c.setAttribute('aria-pressed', c === chip ? 'true' : 'false');
          });
          if (img) {
            img.src = chip.getAttribute('data-src');
            img.alt = chip.getAttribute('data-alt') || '';
          }
          if (label) label.textContent = chip.getAttribute('data-label') || '';
        });
      });
    });
  }

  /* ---------- 3Dカップ（案C-1）：近づいたら読み込む ---------- */
  var loading3D = false;
  function init3D() {
    var roots = document.querySelectorAll('[data-tpc-3d]');
    if (!roots.length) return;
    if (window.TPC3D && typeof window.TPC3D.mount === 'function') {
      window.TPC3D.mount(document);
      return;
    }
    var src = roots[0].getAttribute('data-tpc-3d-src');
    if (!src) return;
    function load() {
      if (loading3D) return;
      loading3D = true;
      var s = document.createElement('script');
      s.src = src;
      s.async = true;
      document.head.appendChild(s);
    }
    if (!hasIO) {
      load();
      return;
    }
    var near = new IntersectionObserver(
      function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) {
          near.disconnect();
          load();
        }
      },
      { rootMargin: '900px 0px' }
    );
    each(roots, function (el) {
      near.observe(el);
    });
  }

  /* ================================================================
     スマホの追従ボタン（右下）
     ファーストビュー・リターン・登録欄のボタンや、フッターが見えている間は隠す
     ================================================================ */
  var floatIO = null;
  function initFloat() {
    var el = document.querySelector('[data-tpc-float]');
    if (!el) return;
    if (!hasIO) {
      el.classList.add('is-on');
      return;
    }
    if (floatIO) floatIO.disconnect();
    var targets = document.querySelectorAll('.tpc-cta, .tpc-register__line, .tpc-footer');
    var shown = [];
    floatIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var i = shown.indexOf(e.target);
        if (e.isIntersecting && i < 0) shown.push(e.target);
        if (!e.isIntersecting && i >= 0) shown.splice(i, 1);
      });
      el.classList.toggle('is-on', shown.length === 0);
    });
    each(targets, function (t) {
      floatIO.observe(t);
    });
    if (!targets.length) el.classList.add('is-on');
  }

  /* ================================================================
     起動
     ================================================================ */
  function init(scope) {
    scope = scope || document;
    initReveal(scope);
    initCounters(scope);
    initParallax(scope);
    initFocus(scope);
    initSound();
    initPickers();
    init3D();
    initFloat();
    updateScrollEffects();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  // テーマエディタでセクションを編集したとき
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });

  // テーマエディタで「もっと詳しく」の中の部品を選んだときは、折りたたみを開く
  document.addEventListener('shopify:block:select', function (e) {
    var fold = e.target && e.target.closest ? e.target.closest('details') : null;
    if (fold) fold.open = true;
  });

  // 「もっと詳しく」を開いたときに、中の数字をカウントアップする（toggle は泡立たないため捕捉で受ける）
  document.addEventListener(
    'toggle',
    function (e) {
      var fold = e.target;
      if (!fold || !fold.matches || !fold.matches('details[data-tpc-fold]') || !fold.open) return;
      if (reduceMotion || designMode) return;
      each(fold.querySelectorAll('.tpc-fm-num__n'), function (el) {
        if (el.__tpcCounted) return;
        el.__tpcCounted = true;
        countUp(el);
      });
    },
    true
  );

  window.TPC = window.TPC || {};
  window.TPC.init = init;
})();

/* ================================================================
   シリーズの切り替え（セクションごと）
   data-tpc-series-scope を付けたセクションの中で、.tpc-sv[data-series] を切り替える。
   - 最初のシリーズ：URLの ?series=…（html の data-tpc-series）→ なければセクションの data-default
   - data-rotate="5"：5秒ごとに次のシリーズへ（ファーストビュー）
   - [data-tpc-series-pick]：押したシリーズを表示（ファーストビューの印、箱の中身のタブ）
   ================================================================ */
(function () {
  var ORDER = ['yorisou', 'hodokeru', 'okuru'];
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = !!(window.Shopify && window.Shopify.designMode);

  function set(scope, value) {
    var before = scope.getAttribute('data-tpc-scope');
    if (before && before !== value) {
      // 前の写真を、新しい写真のフェードインが終わるまで下に残す
      var fades = scope.querySelectorAll('[data-tpc-xfade]');
      for (var f = 0; f < fades.length; f++) {
        var el = fades[f];
        clearTimeout(el.__tpcPrev);
        if (el.getAttribute('data-series') === before) {
          el.classList.add('is-prev');
          el.__tpcPrev = setTimeout(function (x) { return function () { x.classList.remove('is-prev'); }; }(el), 1600);
        } else {
          el.classList.remove('is-prev');
        }
      }
    }
    scope.setAttribute('data-tpc-scope', value);
    var picks = scope.querySelectorAll('[data-tpc-series-pick]');
    for (var i = 0; i < picks.length; i++) {
      picks[i].setAttribute('aria-pressed', picks[i].getAttribute('data-tpc-series-pick') === value ? 'true' : 'false');
    }
  }

  function setup(scope) {
    if (scope.__tpcSeries) return;
    scope.__tpcSeries = true;
    // 切り替える写真は、最初から読み込んでおく（切り替えた瞬間に、まだ読み込まれていないことがないように）
    var lazy = scope.querySelectorAll('[data-tpc-xfade] img[loading="lazy"]');
    for (var l = 0; l < lazy.length; l++) lazy[l].loading = 'eager';
    var fromUrl = root.getAttribute('data-tpc-series');
    var start = ORDER.indexOf(fromUrl) >= 0 ? fromUrl : scope.getAttribute('data-default') || 'hodokeru';
    set(scope, start);

    var seconds = parseFloat(scope.getAttribute('data-rotate'));
    var timer = null;
    function next() {
      if (document.hidden) return;
      var i = ORDER.indexOf(scope.getAttribute('data-tpc-scope'));
      set(scope, ORDER[(i + 1) % ORDER.length]);
    }
    function play() {
      if (!seconds || reduce || design) return;
      clearInterval(timer);
      timer = setInterval(next, seconds * 1000);
    }
    scope.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-tpc-series-pick]') : null;
      if (!btn || !scope.contains(btn)) return;
      set(scope, btn.getAttribute('data-tpc-series-pick'));
      play();
    });
    play();
  }

  function init() {
    var scopes = document.querySelectorAll('[data-tpc-series-scope]');
    if (!scopes.length) return;
    for (var i = 0; i < scopes.length; i++) setup(scopes[i]);
    root.classList.add('tpc-sjs');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

/* ================================================================
   スクロール中のメニュー（2026-10-14）
   - PC：ヘッダーが画面の外に出たら .is-stuck を付けて、画面の上に固定する。
     ページの流れの中にあるヘッダー（重ねていないもの）は、固定で抜けた分の高さを親に残して、ずれないようにする。
   - スマホ：下のメニューで、いま見ている章のリンクに .is-current を付ける。
   ================================================================ */
(function () {
  var header = document.querySelector('[data-tpc-sticky]');
  var mq = window.matchMedia ? window.matchMedia('(min-width: 990px)') : null;
  if (header && mq) {
    var holder = header.parentElement;
    var limit = 0;
    var measure = function () {
      if (header.classList.contains('is-stuck')) return;
      var inFlow = getComputedStyle(header).position !== 'absolute';
      holder.style.minHeight = inFlow ? header.offsetHeight + 'px' : '';
      limit = header.offsetTop + header.offsetHeight + 40;
    };
    var update = function () {
      var on = mq.matches && window.scrollY > limit;
      if (on !== header.classList.contains('is-stuck')) header.classList.toggle('is-stuck', on);
    };
    measure();
    window.addEventListener('resize', function () { header.classList.remove('is-stuck'); measure(); update(); });
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  var tabbar = document.querySelector('[data-tpc-tabbar]');
  if (tabbar) {
    // ファーストビュー（ヘッダーの次のセクション）の下端を100px過ぎたら表示する
    var headerSection = tabbar.closest('.shopify-section') || tabbar.parentElement;
    var heroSection = headerSection ? headerSection.nextElementSibling : null;
    var hero = heroSection ? heroSection.querySelector('section') || heroSection : null;   // ファーストビューの本体（下に続く要点の帯は含めない）
    var showAt = function () {
      if (!hero) return 0;
      return hero.getBoundingClientRect().bottom + window.scrollY + 100;
    };
    var at = showAt();
    var toggle = function () { tabbar.classList.toggle('is-on', window.scrollY > at); };
    window.addEventListener('scroll', toggle, { passive: true });
    window.addEventListener('resize', function () { at = showAt(); toggle(); });
    window.addEventListener('load', function () { at = showAt(); toggle(); });
    toggle();
  }
  if (tabbar && 'IntersectionObserver' in window) {
    var links = [].slice.call(tabbar.querySelectorAll('a[href^="#"]'));
    var map = new Map();
    links.forEach(function (a) {
      var t = document.getElementById(a.getAttribute('href').slice(1));
      if (t) map.set(t, a);
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var a = map.get(e.target);
        if (!a) return;
        if (e.isIntersecting) {
          links.forEach(function (l) { l.classList.toggle('is-current', l === a); });
        }
      });
    }, { rootMargin: '-45% 0px -50% 0px' });
    map.forEach(function (_, t) { io.observe(t); });
  }
})();

/* ================================================================
   案C-2・Makuake版のファーストビュー：写真を順に切り替える（2026-10-14）
   [data-tpc-frames="3"]：3秒ごとに次の写真へ。新しい写真をいちばん上でフェードインさせ、
   前の写真はフェードインが終わるまで、その下に表示したままにする。
   ================================================================ */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function setup(box) {
    if (box.__tpcFrames) return;
    box.__tpcFrames = true;
    var frames = [].slice.call(box.querySelectorAll('.tpc-c2-hero__frame'));
    if (frames.length < 2 || reduce) return;
    var seconds = parseFloat(box.getAttribute('data-tpc-frames')) || 3;
    var bar = box.querySelector('.tpc-c2-hero__bar span');
    box.style.setProperty('--frame-time', seconds + 's');
    frames.forEach(function (f) {
      var img = f.querySelector('img[loading="lazy"]');
      if (img) img.loading = 'eager';
    });
    var i = 0;
    var prevTimer = null;
    function show(k, first) {
      var old = frames[i];
      i = k;
      frames.forEach(function (f, n) {
        f.classList.toggle('is-active', n === i);
        if (n !== i && f !== old) f.classList.remove('is-prev');
      });
      if (!first && old !== frames[i]) {
        old.classList.add('is-prev');
        clearTimeout(prevTimer);
        prevTimer = setTimeout(function () { old.classList.remove('is-prev'); }, 1100);
      }
      if (bar) {
        bar.classList.remove('is-running');
        void bar.offsetWidth;
        bar.classList.add('is-running');
      }
    }
    box.classList.add('is-rotating');
    show(0, true);
    setInterval(function () {
      if (document.hidden) return;
      show((i + 1) % frames.length, false);
    }, seconds * 1000);
  }
  function init() {
    [].forEach.call(document.querySelectorAll('[data-tpc-frames]'), setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

/* 「詳しく読む」（[data-tpc-more]）：タブレット・PC（750px以上）では、開いたまま見せる */
(function () {
  var mq = window.matchMedia ? window.matchMedia('(min-width: 750px)') : null;
  function apply() {
    if (!mq) return;
    [].forEach.call(document.querySelectorAll('[data-tpc-more]'), function (d) {
      if (mq.matches) d.open = true;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();
  if (mq && mq.addEventListener) mq.addEventListener('change', apply);
  document.addEventListener('shopify:section:load', apply);
})();

/* ================================================================
   カードの行をそろえる（[data-tpc-rows]）：PCで横に並んだカードの、同じ項目の高さを一番高いものに合わせる。
   文章の行数がカードごとに違っても、下の項目（評価・カップ・リンクなど）が横一列に並ぶ。
   data-tpc-rows は上から順の項目のセレクタ（カンマ区切り）、data-tpc-row-item はカード1枚のセレクタ
   ================================================================ */
(function () {
  var mq = window.matchMedia ? window.matchMedia('(min-width: 990px)') : null;
  function run() {
    var lists = document.querySelectorAll('[data-tpc-rows]');
    for (var i = 0; i < lists.length; i++) {
      var list = lists[i];
      var items = list.querySelectorAll(list.getAttribute('data-tpc-row-item'));
      var sels = list.getAttribute('data-tpc-rows').split(',');
      for (var j = 0; j < sels.length; j++) {
        var els = [];
        for (var k = 0; k < items.length; k++) {
          var el = items[k].querySelector(sels[j]);
          if (el) { el.style.minHeight = ''; els.push(el); }
        }
        if (!mq || !mq.matches || els.length < 2) continue;
        var max = 0;
        for (k = 0; k < els.length; k++) max = Math.max(max, els[k].getBoundingClientRect().height);
        for (k = 0; k < els.length; k++) els[k].style.minHeight = max + 'px';
      }
    }
  }
  var t = 0;
  function later() { clearTimeout(t); t = setTimeout(run, 120); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  window.addEventListener('load', run);
  window.addEventListener('resize', later);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(run);
  document.addEventListener('shopify:section:load', run);
})();

/* ================================================================
   案C-1の3D VIEW（[data-tpc-view-scroll]）：スマホでは、説明文を読み終えるまで .is-reading を付ける
   （カップを小さく右上に寄せ、色の切り替えを隠す。読み終えたら元の大きさに戻して操作できるように）
   ================================================================ */
(function () {
  var mq = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
  var ticking = false;
  function update() {
    ticking = false;
    var secs = document.querySelectorAll('[data-tpc-view-scroll]');
    for (var i = 0; i < secs.length; i++) {
      var sec = secs[i];
      var paras = sec.querySelectorAll('.tpc-c1-view__para');
      var last = paras[paras.length - 1];
      var reading = false;
      if (last && mq && mq.matches) {
        var vh = window.innerHeight || document.documentElement.clientHeight;
        reading = last.getBoundingClientRect().bottom > vh * 0.3;
      }
      sec.classList.toggle('is-reading', reading);
    }
  }
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  document.addEventListener('shopify:section:load', onScroll);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update);
  else update();
})();

/* ================================================================
   スマホ：写真に文章を重ねる章（.tpc-chap--overlay）を読み終えるまで、
   下のメニュー（.tpc-tabbar）と右下のLINEボタン（.tpc-float）を出さない（html.tpc-hold-ui）
   ================================================================ */
(function () {
  var mq = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
  var ticking = false;
  function update() {
    ticking = false;
    var sec = document.querySelector('.tpc-chap--overlay');
    var hold = false;
    if (sec && mq && mq.matches) {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      hold = sec.getBoundingClientRect().bottom > vh + 2;
    }
    document.documentElement.classList.toggle('tpc-hold-ui', hold);
  }
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  document.addEventListener('shopify:section:load', onScroll);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update);
  else update();
})();

/* ================================================================
   湯気（[data-tpc-steam]）：写真の切り抜き（object-fit: cover と object-position）に合わせて、
   写真の中のコーヒーの位置に重ね、canvas に細い湯気を描く。
   data-x / data-y は写真の左上からの割合（湯気の根もと）、data-w は幅の割合
   ================================================================ */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var RISE = 1.9; // 湯気の高さ（幅に対する倍率）

  function place(el) {
    var media = el.parentNode;
    var img = media && media.querySelector('img');
    if (!img || !img.naturalWidth) return;
    var cw = media.clientWidth, ch = media.clientHeight;
    if (!cw || !ch) return;
    var r = img.naturalWidth / img.naturalHeight;
    var w, h;
    if (cw / ch > r) { w = cw; h = cw / r; } else { h = ch; w = ch * r; }
    var pos = (getComputedStyle(img).objectPosition || '50% 50%').split(' ');
    var px = parseFloat(pos[0]) / 100, py = parseFloat(pos[1] || '50%') / 100;
    if (isNaN(px)) px = 0.5;
    if (isNaN(py)) py = 0.5;
    var ox = (cw - w) * px, oy = (ch - h) * py;
    var sw = w * parseFloat(el.getAttribute('data-w') || 0.2);
    var x = ox + w * parseFloat(el.getAttribute('data-x'));
    var y = oy + h * parseFloat(el.getAttribute('data-y'));
    el.style.width = sw + 'px';
    el.style.height = sw * RISE + 'px';
    el.style.left = x - sw / 2 + 'px';
    el.style.top = y - sw * RISE + 'px';
    if (el.__steam) el.__steam.resize();
    el.classList.add('is-ready');
  }

  // 湯気の粒：根もとから生まれ、ゆらぎながら昇って、広がりながら消える
  function Steam(el) {
    var cv = document.createElement('canvas');
    var ctx = cv.getContext('2d');
    el.innerHTML = '';
    el.appendChild(cv);
    var W = 0, H = 0, dpr = Math.min(window.devicePixelRatio || 1, 2);
    var parts = [], last = 0, acc = 0, running = false, visible = false, raf = 0;

    function resize() {
      W = el.clientWidth; H = el.clientHeight;
      cv.width = Math.max(1, Math.round(W * dpr));
      cv.height = Math.max(1, Math.round(H * dpr));
    }

    function spawn(t) {
      var life = 3.6 + Math.random() * 2.4;
      parts.push({
        born: t,
        life: life,
        x0: W * (0.5 + (Math.random() - 0.5) * 0.46),
        r0: W * (0.035 + Math.random() * 0.035),
        r1: W * (0.16 + Math.random() * 0.12),
        amp: W * (0.05 + Math.random() * 0.09),
        freq: 0.35 + Math.random() * 0.45,
        ph: Math.random() * Math.PI * 2,
        drift: (Math.random() - 0.5) * 0.25,
        a: 0.17 + Math.random() * 0.14,
        stretch: 1.5 + Math.random() * 0.9
      });
    }

    function frame(now) {
      var t = now / 1000;
      var dt = last ? Math.min(t - last, 0.1) : 0;
      last = t;
      acc += dt * 16; // 1秒に16粒ほど
      while (acc >= 1) { spawn(t); acc -= 1; }
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.clearRect(0, 0, W, H);
      var wind = Math.sin(t * 0.23) * 0.06 + Math.sin(t * 0.61) * 0.03;
      for (var i = parts.length - 1; i >= 0; i--) {
        var q = parts[i];
        var p = (t - q.born) / q.life;
        if (p >= 1) { parts.splice(i, 1); continue; }
        var age = t - q.born;
        var y = H * (1 - p * 0.98);
        var x = q.x0 + Math.sin(q.ph + age * q.freq * Math.PI * 2) * q.amp * (0.25 + p) + (q.drift + wind) * W * p * 1.6;
        var r = q.r0 + (q.r1 - q.r0) * Math.pow(p, 0.8);
        var alpha = q.a * Math.min(1, p / 0.12) * Math.pow(1 - p, 1.6);
        ctx.save();
        ctx.translate(x, y);
        ctx.rotate(Math.sin(q.ph + age * 0.9) * 0.35);
        ctx.scale(1, q.stretch);
        var g = ctx.createRadialGradient(0, 0, 0, 0, 0, r);
        g.addColorStop(0, 'rgba(255,255,255,' + alpha + ')');
        g.addColorStop(0.4, 'rgba(255,255,255,' + alpha * 0.55 + ')');
        g.addColorStop(1, 'rgba(255,255,255,0)');
        ctx.fillStyle = g;
        ctx.beginPath();
        ctx.arc(0, 0, r, 0, Math.PI * 2);
        ctx.fill();
        ctx.restore();
      }
      if (running) raf = requestAnimationFrame(frame);
    }

    function update() {
      var on = visible && !document.hidden;
      if (on && !running) { running = true; last = 0; raf = requestAnimationFrame(frame); }
      else if (!on && running) { running = false; cancelAnimationFrame(raf); }
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { visible = es[es.length - 1].isIntersecting; update(); }).observe(el);
    } else {
      visible = true;
    }
    document.addEventListener('visibilitychange', update);
    resize();
    // 開いたときから湯気が立っているように、少し進めておく
    var t0 = performance.now() / 1000;
    for (var k = 0; k < 70; k++) spawn(t0 - 5 + k * (5 / 70));
    update();
    return { resize: resize };
  }

  function all() {
    var els = document.querySelectorAll('[data-tpc-steam]');
    for (var i = 0; i < els.length; i++) {
      (function (el) {
        if (reduce) return;
        if (!el.__steam && document.createElement('canvas').getContext) el.__steam = Steam(el);
        var img = el.parentNode.querySelector('img');
        if (img && !img.complete) img.addEventListener('load', function () { place(el); }, { once: true });
        place(el);
      })(els[i]);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all);
  else all();
  window.addEventListener('resize', all);
  document.addEventListener('shopify:section:load', all);
})();

/* ================================================================
   文節で折り返す：iPhoneのSafariなど word-break: auto-phrase に対応していないブラウザで、
   文節の切れ目に <wbr> を入れて、それ以外では折り返さないようにする（「エッ／セイ」のような折り返しを防ぐ）
   ================================================================ */
(function () {
  if (window.CSS && CSS.supports && CSS.supports('word-break', 'auto-phrase')) return;
  var TARGETS = '.tpc-chap__line, .tpc-c1-view__line, .tpc-feature__text--lines .tpc-feature__line, .tpc-c2-hero__point, .tpc h2, .tpc h3';
  // 切れ目にするのは、①読点・句点などの後ろ、②ひらがなの後ろに、漢字・カタカナ・数字・英字・かぎかっこが続くところ
  //   例：カップの|4色は、|4編の|エッセイとつながっています。
  var HIRA = /[ぁ-ゟ]/;
  var CONTENT = /[一-鿿㐀-䶿ァ-ヺヽ-ヿA-Za-z0-9０-９Ａ-Ｚａ-ｚ々〆「『（(〈《【]/;
  var STOP = /[、。，．！？!?]/;
  var PARTICLE = /[のにをはがとでへもや]/;
  var KANJI = /[\u4e00-\u9fff\u3400-\u4dbf々]/;
  var CLOSE = /[」』）)〉》】]/;
  var NOSTART = /[、。，．！？!?」』）)〉》】ー・…ゝゞっゃゅょぁぃぅぇぉッャュョァィゥェォ\s]/;

  function phrases(text) {
    var out = [], cur = '';
    for (var i = 0; i < text.length; i++) {
      var c = text.charAt(i), prev = i ? text.charAt(i - 1) : '';
      var cut = false;
      if (cur && !NOSTART.test(c)) {
        if (STOP.test(prev)) cut = true;
        else if (CLOSE.test(prev) && !HIRA.test(c)) cut = true;
        else if (HIRA.test(prev) && CONTENT.test(c)) {
          var pp = i > 1 ? text.charAt(i - 2) : '';
          // 「お湯」「ご褒美」や、「立ち上がる」「書き下ろし」（漢字＋送りがな1字＋漢字）は切らない
          cut = !(/[おご]/.test(prev) && /[\u4e00-\u9fff]/.test(c)) && !(KANJI.test(pp) && KANJI.test(c) && !PARTICLE.test(prev));
        }
      }
      if (cut) { out.push(cur); cur = ''; }
      cur += c;
    }
    if (cur) out.push(cur);
    return out;
  }

  function apply(el) {
    if (el.__tpcPhrase) return;
    el.__tpcPhrase = true;
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    for (var n = walker.nextNode(); n; n = walker.nextNode()) if (n.nodeValue.trim().length > 1) nodes.push(n);
    nodes.forEach(function (node) {
      var ps = phrases(node.nodeValue);
      if (ps.length < 2) return;
      var frag = document.createDocumentFragment();
      ps.forEach(function (p, i) {
        if (i) frag.appendChild(document.createElement('wbr'));
        frag.appendChild(document.createTextNode(p));
      });
      node.parentNode.replaceChild(frag, node);
    });
    el.classList.add('is-phrased');
  }

  function all() {
    [].forEach.call(document.querySelectorAll(TARGETS), apply);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all);
  else all();
  document.addEventListener('shopify:section:load', all);
})();

/* ================================================================
   Makuakeの販売開始（[data-tpc-at] の時刻）を過ぎたら、開いているページのボタンの文言とリンク先を差し替える
   （サーバー側でも切り替わるが、キャッシュされたページや、開いたままのページのため。2026-10-27）
   ================================================================ */
(function () {
  function apply() {
    var now = Date.now() / 1000;
    var next = Infinity;
    [].forEach.call(document.querySelectorAll('[data-tpc-at]'), function (el) {
      var at = parseInt(el.getAttribute('data-tpc-at'), 10);
      if (!at) return;
      if (now < at) { next = Math.min(next, at); return; }
      if (el.hasAttribute('data-tpc-hide')) { el.parentNode && el.parentNode.removeChild(el); return; }
      var href = el.getAttribute('data-tpc-href');
      if (href) {
        el.setAttribute('href', href);
        // Makuakeは同じタブで開く（新しいタブだと、LINEなどのアプリ内ブラウザで「ページを離れますか」の確認が出るため）
        if (/line\.me|lin\.ee/.test(href)) { el.setAttribute('target', '_blank'); el.setAttribute('rel', 'noopener'); }
        else { el.removeAttribute('target'); }
      }
      var text = el.getAttribute('data-tpc-text');
      if (text !== null) el.textContent = text;
      el.removeAttribute('data-tpc-at');
    });
    if (next !== Infinity) setTimeout(apply, Math.min((next - now) * 1000 + 500, 2147483000));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();
  document.addEventListener('visibilitychange', function () { if (!document.hidden) apply(); });
})();
